import { createAction } from '@reduxjs/toolkit';
import { notificationsSlice } from './slice';

export const loadNotifications = createAction<{ page?: number } | undefined>(
  'notifications/loadNotifications',
);
export const loadMoreNotifications = createAction(
  'notifications/loadMoreNotifications',
);
export const syncUnreadCount = createAction('notifications/syncUnreadCount');
export const markRead = createAction<string>('notifications/markRead');
export const markUnread = createAction<string>('notifications/markUnread');
export const markAllRead = createAction('notifications/markAllRead');

export const {
  setLoading,
  setNotificationsPage,
  setUnreadCount,
  markItemRead,
  markItemUnread,
  setAllRead, // state update -  Redux state
  prependNotification,
} = notificationsSlice.actions;
